<template>
  <div :style="{'margin-top': bottomTable}">
    <div v-if="tableData.row.length">
      <span v-if="isFuture" class="mk-current__table mk-future__title">{{$t('mc.pageTitles.futureMc')}}</span>
      <base-table
        :head="tableData.head"
        :columnTemplates="tableData.sizeColumn">
        <base-table-row
            v-for="(element) of MkWithSubArrays[page - 1]"
            :key="`${element.id}mimk-tabke-row`"
            :columnTemplates="tableData.sizeColumn"
            :style="bookingsTags && Array.isArray(bookingsTags[element.id]) && bookingsTags[element.id].length ? 'position: relative; padding-bottom: 40px;' : ''"
        >
          <base-table-column class="cell-content__align-start table-column_elipsis">
            <div class="flex-column">
              <span class="table__name mb-10" v-if="element.student.name">{{element.student.name}}</span>
              <span class="mb-10" v-if="element.student.info">{{element.student.info}}</span>
              <span class="table__segment" v-if="element.extraInformation.segment">{{segmentIdToNameSegment(element.extraInformation.segment)}}</span>
              <span class="table__segment" v-if="element.extraInformation.tcNumber > 0">{{ $t("mc.detailsMc.tcNumber") }}: {{ +element.extraInformation.tcNumber + 1 }}</span>
            </div>
          </base-table-column>
          <base-table-column>
            <router-link :to="`/master-classes/detail/${element.id}`" target="_blank" v-tooltip="$t('mc.tooltips.detailMc')">
              <inline-svg
                class="icon-in-mk"
                :src="require(`@/assets/svg/link.svg`)"
              />
            </router-link>
          </base-table-column>
          <base-table-column class="cell-content__align-start">
            <div>
              <span>{{element.date.start}}</span>
              <br />
              <span>{{element.date.hour}}</span>
            </div>
          </base-table-column>
          <base-table-column class="cell-content__align-start">
            <div>
              <a v-if="element.extraInformation.backofficeLink" :href="`${element.extraInformation.backofficeLink}`" target="_blank">{{$t('mc.tables.cols.goBackoffice')}}</a>
              <br />
              <a v-if="element.extraInformation.amoLink" :href="`${element.extraInformation.amoLink}`" target="_blank">{{$t('mc.tables.cols.goAmo')}}</a>
              <br />
              <span v-if="element.extraInformation.parentName">{{$t('mc.tables.cols.parent')}}: {{element.extraInformation.parentName}}</span>
              <br />
              <a 
                :href="`https://web.whatsapp.com/send?phone=${element.extraInformation.parentNumber}`" 
                v-if="element.extraInformation.parentNumber">
                {{element.extraInformation.parentNumber}}
              </a>
            </div>
          </base-table-column>
          <base-table-column class="butons-column align-center">
          <div v-if="element.status === $store.state.statuses.mcStatuses.booked || element.status === $store.state.statuses.mcStatuses.inWork">
            <div
              v-if="element.status === $store.state.statuses.mcStatuses.booked">
              <div>
                <button 
                  class="btn btn_blue table-button"
                  @click="choiseTotal($store.state.statuses.mcStatuses.inWork, element.id)">
                  {{$t('mc.mc.buttons.startMc')}}
                </button>
                <button 
                  class="btn table-button"  
                  @click="choiseTotal($store.state.statuses.mcStatuses.cancel, element.id, true)">
                  {{$t('mc.mc.buttons.studentNotComing')}}
                </button>
              </div>
            </div>
            <div class="align-center" v-if="element.status === $store.state.statuses.mcStatuses.inWork">
              <button 
                class="btn btn_blue table-button" 
                @click="choiseTotal($store.state.statuses.mcStatuses.success, element.id)">
                {{$t('mc.mc.buttons.success')}}
              </button>
              <button 
                class="btn table-button" 
                @click="choiseTotal($store.state.statuses.mcStatuses.cancel, element.id)">
                {{$t('mc.mc.buttons.notSuccess')}}
              </button>
            </div>
          </div>
          <div class="cell-content__status" v-else>
            <inline-svg
              v-if="element.status && element.svgName"
              :src="require(`@/assets/svg/${element.svgName}.svg`)"
              class="cell-content__status-icon"
            />
            <span>
              {{element.status_translated}}
            </span>
          </div>
          <div class="report-buttons">
            <button
              v-if="showReporTctButton(element.status, element.extraInformation.tcReport)"
              class="btn report-button report-button_mc"
              @click="callReportMcModal(element)">
              <img
                svg-inline
                class="report-icon report-icon_mc"
                src="@/assets/svg/report-mc.svg"
              >
            </button>
            <button
                v-if="element.extraInformation.reportId"
                class="btn report-button report-button_mc--blue"
                @click="downloadReport(element.extraInformation.reportId)">
              <img
                  svg-inline
                  class="report-icon report-icon_mc"
                  src="@/assets/svg/report-mc.svg"
                  :title="$t('mc.mc.buttons.downloadReport')"
              >
            </button>
            <!--  v-if="element.extraInformation.paymentReport" -->
            <!-- <button
              v-if="(element.status === $store.state.statuses.mcStatuses.success ||
                element.status === $store.state.statuses.mcStatuses.inWork) &&
                role === 'admin'"
              class="btn report-button report-button_payment"
              @click="callReportPaymentModal(element)">
              <img svg-inline class="report-icon report-icon_payment" src="@/assets/svg/report-payment.svg">
            </button> -->
          </div>
          </base-table-column>
          <base-table-column v-if="zoomActive">
            <div class="zoom-links-wrapper" v-if="element.zoom_start_url || element.zoom_join_url">
              <a
                  v-if="element.zoom_start_url && !isZoomButtonActive(element)"
                  href="javascript:void(0)"
                  class="zoom-start-link zoom-start-link--disabled"
                  v-tooltip="zoomStartUrlTooltip(element)"
              >
                <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
              </a>
              <a
                  v-else-if="element.zoom_start_url"
                  :href="element.zoom_start_url"
                  class="zoom-start-link"
                  target="_blank"
                  v-tooltip="zoomStartUrlTooltip(element)"
              >
                <inline-svg :height="54" :src="require(`@/assets/svg/zoom-play.svg`)"></inline-svg>
              </a>
              <a
                  v-if="element.zoom_join_url"
                  href="javascript:void(0)"
                  @click="copyToClipboard(element.zoom_join_url)"
                  class="zoom-join-link"
                  v-tooltip="$t('mc.zoom.copyZoom')"
              >
                  <span>
                    <inline-svg :height="16" :src="require(`@/assets/svg/upload-icon-white.svg`)"></inline-svg>
                  </span>
              </a>
            </div>
          </base-table-column>
          <div style="position: absolute;bottom: 0;padding-left: 15px;" v-if="bookingsTags && Array.isArray(bookingsTags[element.id])">
            <Tags :show-title="false" :modify-ability="false" tags-wrapper-style="width: calc(100vw - 400px);" :prop-tags="bookingsTags[element.id]"></Tags>
          </div>
        </base-table-row>
      </base-table>
      <div class="pagination">
        <Count @changeCountsOnPage="changeCountsOnPage" v-if="tableData.row.length > perPage"/>
        <pagination
          v-model="page"
          :records="tableData.row.length"
          :per-page="perPage"
          :options="{texts: false}"
          @paginate = "setPage"
        />
      </div>
    </div>
    <div 
      class="empty-mk-title" 
      v-if="!tableData.row.length && emptyTableTitleName">
      {{emptyTableTitleName}} {{$t('mc.mc.mcNotFoundTitleStart')}} {{emptyTitleDate}} 
      <template v-if="searchedString">{{$t('mc.mc.mcNorFoundSearch')}}</template>
    </div>
  </div>
</template>

<script>
import segmentIdToNameSegment from "@/helpers/segmentIdToNameSegment"
import cookie from 'js-cookie'
import apiMimk from '@/api/master-classes/mimk'
import {mimkTable} from "@/helpers/tableConstructor"
import scrollToContent from "@/helpers/scrollToContent"
import {mockDataPayment} from "@/helpers/mockDataPayment"
import createSubarrays from "@/helpers/createSubarrays"
import config from "@/config"
import Count from '@/components/UI/CountElementsOnPage'
import Tags from "@/components/Supervisor/Tags"
import copyToClipboard from "@/helpers/copyToClipboard";
import { isDateTimeInRange } from "@/helpers/commonHelpers";
export default {
  components: {
    Count,
    Tags,
  },
  data() {
    return {
      segmentIdToNameSegment,
      mockDataPayment,
      config,
      localStaticTableData: [],
      tableData: {
        head: [
          this.$t('mc.tables.titles.student'),
          '',
          this.$t('mc.tables.titles.date'),
          this.$t('mc.tables.titles.additionally'),
          this.$t('mc.tables.titles.status')],
        sizeColumn: '',
        row: {}
      },
      perPage: 10,
      page: 1,
      searchedString: false,
    }
  },
  props: {
    zoomActive: {
      type: Boolean,
      default: false,
    },
    choisenMimkIdByAdmin: {
      type: Number, String,
      required: false
    },
    startedPeriod : {
      type: String,
      required: true,
    },
    finishedPeriod : {
      type: String,
      required: true,
    },
    emptyTableTitleName: {
      type: String,
      required: true,
      default: ''
    },
    isFinished: {
      type: Boolean,
      required:false,
      default: false
    },
    isFuture: {
      type: Boolean,
      required:false,
      default: false
    },
    isCurrent: {
      type: Boolean,
      required:false,
      default: false
    },
    propsTableData: {
      type: Array,
      required: true
    },
    tagsObject: {
      type: Object,
      default: () => {},
    },
    sizeColumn: {
      type: String,
       required: true
    }
  },
  async created() {
  //  let element = {"id":"625d1becb6960307d899bebd","student":{"name":"Тест Картошки","info":null},"date":{"start":"18.04.2022","hour":"12:00"},"extraInformation":{"parentName":null,"parentNumber":null,"segment":6,"tcReport":"62f4ab2289c31f4bbbc70592","amoLink":"https://kodland.amocrm.ru/leads/detail/33213492"},"status_translated":"В работе","status":"В работе","svgName":"time-mk"}
  //  this.callReportPaymentModal(element)
    if (!localStorage.getItem('countsOnPage')) {
      this.perPage = 10
    } else {
      this.perPage = JSON.parse(localStorage.getItem('countsOnPage')).value
    }
    if (this.zoomActive) {
      this.tableData.head.push('Zoom')
    }
    this.localStaticTableData = new mimkTable(this.propsTableData)
    this.tableData.sizeColumn = this.sizeColumn
    this.buildTable(this.propsTableData)
  },
  computed: {
    bookingsTags() {
      return this.$store.state.tags.bookingsTagsObject
    },
    bottomTable() {
      return this.isFuture ? '30px' : 0
    },
    role() {
      return cookie.get("role");
    },
    emptyTitleDate() {
      if (this.startedPeriod && this.finishedPeriod) {
        return this.$t('mc.mimk.period', [this.startedPeriod, this.finishedPeriod])
      }else {
        return this.$t('mc.mimk.today')
      }
    }
  },
  methods: {
    isZoomButtonActive(el) {
      return isDateTimeInRange(null, el.zoom_session_starts_at, el.zoom_session_ends_at, this.$store.state.user.segment.tz_offset) &&
          (this.$store.state.user.user.id === el.mimkId || this.$store.state.user.user.role === 'supervisor' || this.$store.state.user.user.role === 'admin')
    },
    zoomStartUrlTooltip(el) {
      const isZoomButtonActive = this.isZoomButtonActive(el)

      if (isZoomButtonActive) return this.$t('mc.zoom.startZoom')

      const now = this.$dayjs(this.$dayjs(new Date()).utc().add(this.$store.state.user.segment.tz_offset, 'second').format('YYYY-MM-DD HH:mm'))
      const startDate = this.$dayjs(el.zoom_session_starts_at)

      if (now.isBefore(startDate)) return this.$t('mc.zoom.prompt2', [startDate.format('HH:mm')])

      if (el.mimkId !== this.$store.state.user.user.id && this.$store.state.user.user.role !== 'supervisor' && this.$store.state.user.user.role !== 'admin') {
        return this.$t('mc.zoom.prompt1')
      }

      return this.$t('mc.zoom.prompt3')
    },
    copyToClipboard(text) {
      copyToClipboard(text, () => {
        this.$toasted.global.all_ok(this.$t('mc.toasts.copyLink'))
      })
    },
    downloadReport(reportId) {
      return apiMimk.downloadReport(reportId)
    },
    showReporTctButton(element, isSendReport) {
      let isSendReportToBoolean = !!isSendReport
      if (element === this.$store.state.statuses.mcStatuses.booked) return false
      if (element === this.$store.state.statuses.mcStatuses.cancel) return false
      else if (!isSendReportToBoolean) return true
      else return false
    },
    async callReportMcModal(element) {
      // const reportMcModalFields = await apiMimk.getReporMcData()
      const reportMcModalFields = await apiMimk.getReporMcData(element)
      let isSuccessRequest = !!reportMcModalFields
      if (!isSuccessRequest) return
      const type = 'tc'
      this.$emit('callReportTypeModal', {
        element,
        reportMcModalFields, 
        type
      })
    },
    async callReportPaymentModal(element) {
      const temperaryMock = (requestedFields) => {
        const mockReportFields = this.mockDataPayment
        return Object.assign(requestedFields, mockReportFields)
      }
      const requestedFields = await apiMimk.getReporPaymentData(element.id)
      temperaryMock(requestedFields)
      let requestPaymentMethod = await apiMimk.getReporPaymentMethod()
      const paymentCurrency = await apiMimk.getReporPaymentCurrency()
      const paymentRegion = await apiMimk.getReportPaymentRegion()
      const paymentMethod = requestPaymentMethod.map((el) => {
        for (let property in el) return {name: el[property]}
      })
      const selectDataObjects = {
        payment_method: paymentMethod,
        payment_currency: paymentCurrency,
        pricing_region: paymentRegion
      }
      const reportMcModalFields = {...requestedFields,...selectDataObjects }
      const isEasyPayment = reportMcModalFields.easy_payment.value
      for (const reportElement in reportMcModalFields) {
        if (isEasyPayment && !Array.isArray(reportMcModalFields[reportElement])) reportMcModalFields[reportElement].readonly = true
        else {
          if (!reportMcModalFields[reportElement].auto  && !Array.isArray(reportMcModalFields[reportElement])) reportMcModalFields[reportElement].value = ''
        }
      }
      const type = 'payment'
      this.$emit('callReportTypeModal', {
        element,
        reportMcModalFields,
        type
      })
    },
    setPage() {
      scrollToContent(this.$el.querySelector('.content'))
    },
    changeCountsOnPage(value) {
      this.perPage = value
      this.buildTable(this.propsTableData)
    },
    //Строим таблицу и пагинируем данные
    buildTable(data) {
      this.tableData.row = new mimkTable(data)
      this.MkWithSubArrays = createSubarrays(this.perPage, this.tableData.row)
    },
    //Метод отправки эмита для изменения статуса МК
    choiseTotal(status, id, studnentReason){
      this.$emit('choiseTotal', {
        status,
        id,
        studnentReason
      })
    },
  }
}
</script>

<style lang="scss" scoped>
  .cell-content__status {
    width: 215px;
  }
  .butons-column {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  .report-icon::v-deep {
    width: 32px;
    height: 32px;
  }
  .report-buttons {
    margin-left: 15px;
  }
.report-button {
  &:first-child {
    margin-bottom: 20px;
  }
  padding: 0 15px;
  width: 55px;
  min-width: auto;
  &_mc {
    padding: 0 15px;
    background: var(--success);
    width: 55px;
    min-width: auto;
  }
  &_mc--blue {
    padding: 0 15px;
    background: var(--main-blue);
    width: 55px;
    min-width: auto;
  }
  &_payment {
    background: var(--main-blue);
  }
}
.table {
  &-button
  {
    &:first-child {
      margin-bottom: 20px;
    }
  }
  &__name {
    color: var(--main-blue);
  }
  &__segment {
    color: var(--grey);
  }
}
.tags {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.tag {
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 5px 13px;
  border-radius: 20px;
  font-size: 13px;
  &-lock {
    width: 12px;
    height: 12px;
    margin-right: 6px;
  }
}
</style>